import React from 'react';

import type { IIcon } from '../types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 30, className, onClick }, ref) {
  return (
    <svg ref={ref} viewBox='0 0 512 512' onClick={onClick} width={size} height={size} className={className}>
      <path fill='#E2E5E7' d='M128,0c-17.6,0-32,14.4-32,32v448c0,17.6,14.4,32,32,32h320c17.6,0,32-14.4,32-32V128L352,0H128z' />
      <path fill='#B0B7BD' d='M384,128h96L352,0v96C352,113.6,366.4,128,384,128z' />
      <polygon fill='#CAD1D8' points='480,224 384,128 480,128 ' />
      <path fill='#7BC087' d='M416,416c0,8.8-7.2,16-16,16H48c-8.8,0-16-7.2-16-16V256c0-8.8,7.2-16,16-16h352c8.8,0,16,7.2,16,16V416z' />
      <g>
        <path
          fill='#FFFFFF'
          d='M117.2,327.8v47.3c0,5.6-4.6,8.8-9.2,8.8c-4.1,0-7.7-3.2-7.7-8.8v-72c0-6.6,5.6-8.8,7.7-8.8 c3.7,0,5.9,2.2,8.1,4.6l28.2,38l29.2-39.4c4.2-5.2,14.6-3.2,14.6,5.6v72c0,5.6-3.6,8.8-7.7,8.8c-4.6,0-8.2-3.2-8.2-8.8v-47.3 l-21.2,26.9c-4.6,5.6-10.4,5.6-14.6,0L117.2,327.8z'
        />
        <path
          fill='#FFFFFF'
          d='M210.3,303.2c0-4.2,3.3-8.8,8.7-8.8h29.6c16.6,0,31.6,11.1,31.6,32.5c0,20.2-15,31.5-31.6,31.5h-21.4v16.9 c0,5.6-3.6,8.8-8.2,8.8c-4.2,0-8.7-3.2-8.7-8.8L210.3,303.2L210.3,303.2z M227.2,310.4v31.9h21.4c8.6,0,15.4-7.6,15.4-15.5 c0-9-6.8-16.4-15.4-16.4L227.2,310.4L227.2,310.4z'
        />
      </g>
      <path fill='#CAD1D8' d='M400,432H96v16h304c8.8,0,16-7.2,16-16v-16C416,424.8,408.8,432,400,432z' />
      <text transform='matrix(1.0197 0 0 1 294 376.4121)' fill='#FFFFFF' fontSize='122.3555px'>
        {'4'}
      </text>
    </svg>
  );
});

export default React.memo(Icon);
